export default __webpack_public_path__ + "static/media/female-icon.d903a167.svg";